/**
 * @desc 获取国家列表
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.ResponseDto<Array<defs.basics.CountryResponseDto>>;
export function request(body: defs.basics.CountryResponseDto, options?: any): Promise<Response> {
  return updateResponse(
    http(URL + `/country/getList`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
